import LoginForm from '../components/LoginForm';

export const Login = () => {
  return (
    <div className="page-container">
      <LoginForm />
    </div>
  );
};

export default Login; 